import { useContext, useEffect, useState } from "react"
import { RiHeart2Line, RiMapPin2Line, RiShoppingBag2Line } from "react-icons/ri"
import { useNavigate } from "react-router-dom"
import { IMAGE_URL, MANAGE_CUSTOMER } from "../../../../Utilities/APIs/APIs"
import Modal from "../../../Partials/Elements/Modal/Modal"
import CRUDButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/CRUDButton"
import ViewButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import ImageCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell"
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ViewCustomer from "./ViewCustomer"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import AppContext from "../../../../AppContext/AppContext"

function Customers() {

    const [customers, setCustomers] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)

    const {employee} = useContext(AppContext)

    const axiosInstance = useAxiosInstance()
    useEffect(() => {

        async function fetchAndSetCustomers() {
            const {data} = await axiosInstance.get(MANAGE_CUSTOMER + 'getAllCustomers')
            setCustomers(data)
        }
        fetchAndSetCustomers()

    }, [axiosInstance])

    function handleClose() {
        setShowModal(false);
        setShowViewSection(false);
    }

    const navigate = useNavigate()

    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Customers (${customers?.length} in total)`}</h1>
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th= 'Customer Name' />
                        <CRUDth th= 'Image' />
                        <CRUDth th= 'Email' />
                        <CRUDth th='Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {customers?.map(customer => (
                            <CRUDTableRow key={customer._id}>
                                <ShortTextCell text={customer.name} />
                                {
                                customer.dp
                                ?
                                <ImageCell imgSrc={IMAGE_URL + customer.dp.slice(6, customer.dp.length)} alt={customer.name} />
                                :
                                <ShortTextCell text='' />
                                }
                                <ShortTextCell text={customer.email} />
                                <td className="action_button_cell">
                                    <ViewButton
                                    setShowModal={setShowModal}
                                    setShowViewSection={setShowViewSection}
                                    targetID={customer._id}
                                    setTargetID={setTargetID}
                                    />
                                    <CRUDButton handleClick={() => navigate('/wishlist_from_customer/' + customer._id)}>
                                        <RiHeart2Line />
                                    </CRUDButton>
                                    <CRUDButton handleClick={() => navigate('/orders_from_customer/' + customer._id)}>
                                        <RiShoppingBag2Line />
                                    </CRUDButton>
                                    <CRUDButton handleClick={() => navigate('/addresses_from_customer/' + customer._id)}>
                                        <RiMapPin2Line />
                                    </CRUDButton>
                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal && 
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Item`)
                    }
                >
                    {
                        showViewSection &&
                            <ViewCustomer
                                targetID={targetID}
                                employee={employee}
                            />
                    }    
                </Modal>
            }
        </>
    )
}

export default Customers